/** The review's draft: restored from this browser when there is one, else built from the proposal; kept on change. */

import type { ProposalOut } from '@/api/types/extractions';
import { useSession } from '@/session/SessionContext';
import { useKeptDraft } from '@/ui/useKeptDraft';

import { draftFromProposal, isDraftOf, storageKey, type TemplateSection } from './fromFilesDraft';

export function useFromFilesDraft(proposal: ProposalOut, template: TemplateSection[]) {
  const userId = useSession().user?.id ?? 'anonymous';
  return useKeptDraft(storageKey(userId, proposal.id), () => draftFromProposal(proposal, template), isDraftOf(proposal.id));
}
